module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch02"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a terrible dream. Even in my sleep, I could feel myself shivering from head to toe, like I had icicles in my veins instead of the thick purple blood of the citizens of my planet. The worst part was the horrible coughing sound echoing in my head, or maybe gagging was a better word, as if someone were choking on a chicken bone. That raspy, terrifying cough sounded heartless and inhuman. I wanted desperately for that dream to end, but I couldn’t shake myself awake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard a pounding on the door of my dressing room, but it sounded like it was a million miles away, coming at me through a thick, gooey haze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy, they need us on the set!” Through the haze, I could hear my costar, Cassidy Cambridge, calling me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to answer her, but my mouth wasn’t working. It was sound asleep too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("“Buddy!” she called again. “What’s going on in there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to open my eyes and respond, but they were heavy with sleep. Since arriving on Earth three weeks before, I was finding that I had to take naps every afternoon in order to stay awake. Maybe I was still getting used to the Earth’s environment, especially in Hollywood, where the weather is hot and dry. There was no way even my expandable stomach could hold all the water I needed to keep myself hydrated, so I had to submerge myself in a bathtub at least an hour a day to keep my life force vital and my scaly skin from peeling off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sorry if the topic of my scaly skin grosses you out, but trust me, seeing me with scaly skin is a lot better than seeing me without it. Underneath, my veins look like wiggly, slimy worms expanding and contracting all over my body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ick. Now even I’m grossed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy, I’m coming in,” Cassidy called, opening the door to my dressing room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat up and shivered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s hot in here,” Cassidy said. “Why are you shivering?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was having a terrible dream that seemed all too real,” I answered. “I felt like I was tied up in a chair and someone blasted me with frigid air. And that a creature near me was choking on a chicken bone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa, Buddy,” Cassidy said. “Your imagination has "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("officially gone wild. Do you think you can check it at the door so we can go to rehearsal?”")])]), _vm._v(" "), _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It just felt so real, Cassidy. And here’s the weird part. I thought I heard my grandmother’s voice calling to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy, your grandmother is twenty million light-years away on a red dwarf planet. Even if she did scream your name, you wouldn’t hear it until you’re old and bald.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, don’t knock baldies,” I snapped. “Remember, underneath this head of gorgeous human hair, the real me is hairless.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cassidy laughed. “I forget that you’re actually bald as an eagle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("Since we don’t have eagles on my planet, I wanted to know what I was being compared to, so I had my brain run a search of all the preprogrammed information it contains. I can process tons of obscure information in nanoseconds. It’s just a thing we aliens do. Thousands of bald eagle facts poured into my head, and just for fun, I picked one to share with Cassidy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you know that bald eagles can see forward and sideways at the same time?” I said, standing up from the couch that had just been moved to my dressing room. (Not to brag, but I’d been told that having your own dressing room couch is the sign of a rising star.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah,” said Cassidy. “Their vision comes in handy for catching rats and other vermin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With my six eyes, I’d be really good at that too. My alien body is pretty cool, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of your alien body,” Cassidy said, pointing to my feet. “Your suction cups are showing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glanced down to check myself out. I was in my humanoid form, which looked exactly like Zane Tracy, a teen idol earthling whose movies Grandma Wrinkle and I watched in secret in her underground cave. Well, at least ninety-six percent of me was Zane Tracy. The toes on my left foot had started to recede and my real body’s suction cups had popped "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("out. The energy I use for my biological alteration must have been running low, and I obviously needed to recharge it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grabbed the titanium amulet I wear around my neck, the one that Grandma Wrinkle had made for me before I left my home planet. Clutching it in my palm, I closed my eyes and concentrated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("Be Zane Tracy")]), _vm._v(",” I chanted under my breath. “"), _c('em', [_vm._v("Be Zane now")]), _vm._v(".”")]), _vm._v(" "), _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But nothing happened to my suction cups. My toes remained alien despite my best chanting. And to make matters worse, my sensory enhancer, a trunklike appendage that grows out of the center of my back, shot up into the air and started to sniff my dressing room. Sensory enhancers love anything that you can taste, smell, feel, hear, or see. They have a mind of their own, which is why the repressive government on my home planet deactivates them when a citizen reaches the age of thirteen. Grandma Wrinkle, who taught me to love movies and art and music in her subterranean secret cave, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("planned for me to escape to Earth on my thirteenth birthday. We both knew that enjoying the colors and sounds and feelings of art was crucial to happiness. That’s why I was here on planet Earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But now, my mischievous sensory enhancer was acting up and making a beeline for Cassidy’s hand. Instinctively, she pulled her hand away and put it in her jacket pocket, but it followed her, snorting and sniffing the entire way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy, can you please call off your overactive appendage?” she said. “It’s really annoying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I said to it. “Behave. What’s got you all riled up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know it’s weird to talk to a body part, but the situation demanded it. My sensory enhancer ignored me, and just dove deeper into Cassidy’s jacket pocket and snorted again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a minute,” Cassidy said. “I think I know the problem. I used strawberry-scented hand lotion this morning. It’s got a pretty strong scent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cassidy took her hand out of her pocket and held it in front of the enhancer’s snout. It inhaled deeply, then let out a loud noise that sounded like a cross between a fart and a moan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that an ‘I like this’ sound or an ‘I hate this’ sound?” Cassidy asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not sure. Let me take a whiff too, and I can give you a better opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("I took hold of Cassidy’s hand and put it up to my nose.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow, that strawberry scent is strong. No wonder my sensory enhancer’s in a snit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to go wash my hands in the makeup room,” Cassidy said. “I hope the soap can get rid of the strawberry scent and the alien slobber at the same time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me,” I said. “My sensory enhancer does not slobber. We don’t have saliva on my planet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you don’t drool on your pillow when you sleep?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good to know,” Cassidy said. As she left my dressing room, she called over her shoulder, “Hurry up and transform into alien Buddy. They’re waiting for us on the set. You know how Duane gets if we’re late. We don’t want him to get his ponytail in a knot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I heard the door close, I sat down on the couch and got serious about transformation. Holding my amulet in my hand, I closed my eyes and chanted, this time putting all my concentration and energy into the words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("Be the real me")]), _vm._v(",” I chanted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I closed my eyes and visualized the alien me. I could feel the titanium of the amulet start to heat up as the liquid crystal inside began to bubble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("Be the real me")]), _vm._v(",” I chanted over and over again. I opened "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("one eye and glanced down at my hand. It still had human fingers that smelled strongly of strawberry, but they were growing longer and looking more like my pointy alien digits.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gradually, I felt an electrical current rising in my body. The hand holding the amulet grew so hot that my palm burned like I was holding a lit match. My forehead started to sweat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Biological alteration generates heat,” Grandma Wrinkle always said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt like I might black out when I was suddenly overcome by a melting feeling. I opened one eye and glanced at the full-length mirror on the back of my dressing room door. I could actually see my Zane Tracy face dissolving into thin air. I could feel the hair on my head receding into my skull and my familiar alien skin creeping up my neck and cheeks to cover my human face. My six eyes popped out and spun around my head. I noticed that they felt really itchy, so I reached up and gave them a rub, being careful not to poke them with my long fingernails. Within seconds, the itching grew worse, and I wondered what was going on. On my planet, the only thing that makes me itch is my allergy to the cleaning solution they put in our body vacuum cleaners. I have to use the solution made for babies, free of dried mycotic fungus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stood up and looked in the mirror, and to my shock,"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v(" I saw that each of my eyes had turned bright red, the same color as my lips. Then I heard a knock on my door.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Buddy, it’s Rosa from wardrobe. I was just coming to see if you needed any help getting into your costume.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I opened the door and walked into the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh great,” Rosa said. “I see you’re already in costume. And hey, I like the new red eyeballs. Did you order new ones for this week’s show?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I could hear Rosa, but I couldn’t see her. She was just a blur. What was happening to my eyes? I rubbed them again, and slowly I began to make out Rosa’s shape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You okay, Buddy?” Rosa asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not really. My eyes are not acting like my eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe those new red lenses aren’t agreeing with you,” Rosa said. “I’d take them out. I mean, they’re cool but they’re not worth suffering for. Just like high heels. I say get rid of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t have high heels,” I said. “My heels are just the normal height.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rosa laughed. “You’re a funny kid, Buddy. Now get going. They’re ready for you on set.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I walked down the hall, my vision slowly returned. I couldn’t figure out what had caused my eyes to act up, but "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("since it went away pretty quickly, I guessed it didn’t matter that much. I decided to just keep an eye on it, so to speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rosa walked next to me and gave me a friendly tap on the back. I noticed that she does that to everyone she likes, so it made me feel good. But my sensory enhancer didn’t like it one bit. It flinched and let out a little squeak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, did I hurt you?” Rosa asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I always squeak before a rehearsal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just to make it seem real, I squeaked a couple more times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know all you actors have superstitions before you perform,” Rosa said. “Your costar Tyler has to wear the same red boxers every time we tape a show. And he won’t let me wash them in between shows.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well there’s something I wish I didn’t know,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We laughed together, and that felt great too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy, you’re so much fun,” Rosa said. “We’re all so glad you’ve joined the cast of "), _c('em', [_vm._v("Oddball Academy")]), _vm._v(". I’m cheering for you every step of the way. Go get ’em, champ.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned and headed for the set, thinking about how much I loved these humans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At least, that’s what I was thinking until I ran smack into Tyler Stone. All it took was one scowl from him and everything changed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 69
// module chunks = 0